import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ClaveUnicaButtonComponent } from '../../components/claveunica-button/claveunica-button.component';
import { ClaveUnicaService } from '../../services/claveunica.service';

@Component({
  selector: 'app-claveunica-login',
  standalone: true,
  imports: [ClaveUnicaButtonComponent],
  templateUrl: './claveunica-login.component.html',
  styleUrl: './claveunica-login.component.css',
})
export class ClaveUnicaLoginComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly titleService = inject(Title);
  private readonly claveUnicaService = inject(ClaveUnicaService);
  private readonly router = inject(Router);

  tokenCU?: string;
  urlError?: string;

  async ngOnInit(): Promise<void> {
    // Cambiar el título de la página
    this.titleService.setTitle('ClaveÚnica');
    try {
      // Capturar query params de la URL
      this.route.queryParams.subscribe((params) => {
        this.tokenCU = params['token'];
        sessionStorage.setItem(this.claveUnicaService.SESSION_STORAGE_KEYS.ERROR_URL, '/claveunica');

        console.warn('ClaveÚnica Login - Query Params:', {
          token: this.tokenCU,
          errorUrl: this.urlError,
        });
      });
    } catch (error: unknown) {
      // Ignorar el error "Navigation in progress" que se lanza intencionalmente
      // durante la redirección exitosa a ClaveÚnica
      if (
        error instanceof Error &&
        error.message === 'Navigation in progress'
      ) {
        return;
      }

      console.error('Error al iniciar autenticación:', error);

      // Determinar el tipo de error
      let tipoError = 'general';

      if (typeof error === 'object' && error !== null && 'status' in error) {
        const status = (error as { status: number }).status;
        if (status === 401) {
          tipoError = 'auth'; // Sesión expirada
        } else if (status === 403) {
          tipoError = 'forbidden'; // Acceso denegado
        } else if (status === 408) {
          tipoError = 'timeout';
        } else if (status >= 500) {
          tipoError = 'server';
        }
      } else if (error instanceof Error && error.message.includes('timeout')) {
        tipoError = 'timeout';
      }

      // Redirigir a la página de error específica de ClaveÚnica
      // Construir la ruta anterior incluyendo el token si existe
      const rutaAnterior = sessionStorage.getItem(this.claveUnicaService.SESSION_STORAGE_KEYS.ERROR_URL);

      this.router.navigate(['/claveunica/error'], {
        state: {
          tipoError,
          rutaAnterior,
        },
      });
    }
  }
}
